<!-- 订单预售后消息卡片 -->
<script lang="ts" setup>
import GoodsCardSimple1 from '../../../../common/goods-card/goods-card-simple1.vue';
import { safeJsonParse } from '@/utils/parse';

interface IProps {
    content: {
        ext?: string;
        icon?: string;
        title?: string;
        type: string;
    };
}

/**
 * 执行动作
 * @：只存在单个子订单，可直接发起售后
 * 1：存在多个子单，需要先选择商品再发起售后
 * 2：人工客服已手工创建预售后单，需要用户确认
 */
enum ActionType {
    ONLY_ONE = '0',
    MULTI = '1',
    MANUAL = '2'
}

interface ExtObj {
    actionType?: ActionType;
    orderId?: string;
    selReturnTypes?: string;
    items?: string;
    preOrderReturnId?: string; // 预创建售后单ID
}

interface GoodsItem {
    goodsId: string;
    subOrderId: string;
}

const props = defineProps<IProps>();

const extObj = computed<ExtObj>(() => safeJsonParse(props.content.ext));
const items = computed<GoodsItem[]>(() => safeJsonParse(extObj.value?.items, []));
const returnTypes = computed<{ key: string; name: string }[]>(() =>
    safeJsonParse(extObj.value?.selReturnTypes, [])
);
</script>

<template>
    <div class="flex flex-col w-84 gap-2">
        <div class="line-clamp-2">{{ content.title }}</div>
        <template v-if="Array.isArray(items) && items.length > 0">
            <template v-if="extObj.actionType === ActionType.ONLY_ONE">
                <GoodsCardSimple1
                    :data="items[0]"
                    :show-num="false"
                />
                <div class="flex flex-col items-center gap-2">
                    <div
                        v-for="i in returnTypes"
                        :key="i.key"
                        class="flex items-center justify-center border-box h-[28px] w-full border border-[#00ccff] text-#00ccff text-center border-solid rounded-20px hover:cursor-not-allowed"
                    >
                        {{ i.name }}
                    </div>
                </div>
            </template>

            <div
                v-else-if="extObj.actionType === ActionType.MULTI"
                class="flex flex-col gap-2"
            >
                <GoodsCardSimple1
                    v-for="i in items"
                    :key="i.goodsId"
                    :data="i"
                    :show-num="true"
                >
                    <div class="btn hover:cursor-not-allowed">确认选择</div>
                </GoodsCardSimple1>
            </div>

            <GoodsCardSimple1
                v-else-if="extObj.actionType === ActionType.MANUAL"
                :data="items[0]"
                :show-num="false"
            >
                <div class="btn hover:cursor-not-allowed">选择新商品</div>
            </GoodsCardSimple1>
        </template>
    </div>
</template>

<style lang="scss" scoped>
.btn {
    display: inline-block;
    box-sizing: border-box;
    height: 28px;
    border-radius: 30px;
    background: #e5faff;
    color: #0cf;
    text-align: center;
    font-size: 14px;
    line-height: 28px;
    font-weight: 500;
    padding: 0 16px;
}
</style>
